<template>
  <el-drawer
    :visible.sync="drawer"
    :direction="direction"
    :modal="false"
    :modal-append-to-body="false"
    :with-header="false"
    :size="430"
    @closed="closedrawer"
    destroy-on-close
  >
    <div class="infinite-list-wrapper">
      <ul
        class="list"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
      >
        <li v-for="i in pointlist">
          <div class="infinite-list-item">
            <div class="item-img">
              <img style="width:100px;height:100px" :src="i.picture" />
            </div>
            <div class="item-span">
              <span class="fontsize">名称:{{ i.deviceName }}</span>
              <span class="fontsize">类型:{{ i.sceneName }}</span>
              <!-- <span class="fontsize">型号:{{ i.deviceModel }}</span>               -->
              <span class="fontsize">用户:{{ i.contacts }}</span>
              <span class="fontsize">电话:{{ i.contactsPhone }}</span>
              <span class="fontsize">地址：{{ i.deviceAddress }}</span>
              <div>
                <el-link icon="el-icon-warning-outline" type="primary" @click="itemClick(i)"
                  >详细信息</el-link
                >
              </div>
            </div>
          </div>
          <div class="divider">
            <el-divider></el-divider>
          </div>
        </li>
      </ul>
      <p class="gengduofont" v-if="loading">加载中...</p>
      <p class="gengduofont" v-if="noMore">没有更多了</p>
    </div>
  </el-drawer>
</template>

<script>
import dataUrl from "../../libs/js/interfaceAddress.js";

export default {
  props: {
    DrawerBool: {
      type: Boolean,
      default: false
    },
    pointData: {
      type: Array,
      default: () => []
    },
    itemClickCallback:{
        type: Function
    },
    close: {
      type: Function
    }
  },
  data() {
    return {
      pointlist: [],
      loading: false,
      drawer: false,
      direction: "rtl",
      index: 0
    };
  },
  watch: {
    DrawerBool: {
      handler: function(newVal, oldVal) {
        this.drawer = newVal;
        if (newVal) {
          this.requestParintlist();
        }
      }
    }
  },
  computed: {
    noMore() {
      return this.pointlist.length >= this.pointData.length;
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  methods: {
    load() {
      this.requestParintlist();
    },
    closedrawer() {
      console.log("关闭事件回调-=-=-=");
      this.drawer = false;
      this.index = 0;
      this.pointlist = [];
      this.close();
    },
    itemClick(item){
       this.closedrawer()
       this.itemClickCallback(item)
    },
    requestParintlist() {
      this.loading = true;

      var newpoint = this.pointData.slice(this.index, this.index + 10);
      var deviceId = "";
      newpoint.filter((item, n) => {
        deviceId += item.deviceId + ",";
      });

      console.log("this.pointData-=-=-=-", this.pointData);
      console.log("下标index-=-=-=-", this.index);
      console.log("newpoint-=-=-=-", newpoint);
      console.log("deviceId-=-=-=-", deviceId);

      this.$http
        .get(dataUrl.interfaceAddress.pointList, {
          params: { deviceIds: deviceId }
        })
        .then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            console.log(res.data.body);
            var postions = res.data.body;
            this.pointlist = this.pointlist.concat(postions);
            this.index = this.pointlist.length;
            console.log("this.pointlist", this.pointlist);
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.infinite-list-wrapper {
  position: absolute;
  left: 0px;
  right: 10px;
  top: 50px;
  bottom: 30px;
  overflow: auto;
  //   background-color: rgb(11, 89, 156);
  .infinite-list-item {
    // left: 10px;
    right: 0px;
    height: 120px;
    margin: 10px;
    width: 100%;
    border-radius: 5px;
    // background-color: #6eafc9;
    position: relative;
    display: flex;
    flex-direction: row;
    // justify-content: center;
    // backdrop-filter: blur(20px);
    // background-color: #e5eb8b !important;
    .item-img {
      margin: auto;
      margin-left: 10px;
      margin-right: 10px;
      //   width: 100px;
      //   height: 100px;
      display: flex;
      flex-direction: column;

      position: relative;
      //   background-color: aqua;
    }
    .item-span {
      margin: auto;
      margin-right: 20px;
      margin-left: 0px;
      display: flex;
      flex-direction: column;
      position: relative;
      //   background-color: aliceblue;
    }
  }
  .fontsize {
    color: rgb(35, 224, 224);
    font-size: 12px;
  }
  .gengduofont {
    color: rgb(131, 226, 233);
    font-size: 17px;
    text-align: center;
  }
  .divider {
    margin: 0px;
    padding: 0px;
    width: 100%;
  }
}
& /deep/ .el-drawer__container ::-webkit-scrollbar {
  display: none;
}
& /deep/ .el-table__body tr.current-row > td {
    background-color: #03438d !important;
    backdrop-filter: blur(20px);
}

& /deep/ .el-drawer.rtl {
  overflow: scroll;
  backdrop-filter: blur(20px);
  background: url("../../../static/img/3.png") no-repeat;
//   border-radius: 25px;
  background-size: 100% 100%;
  background-size: scale-down;
}
& /deep/ .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: -20px;
//   bottom: -30px;
  height: 102%;
  width: 100%;
}
& /deep/ .el-divider{
    margin: 8px 8px;
    background: 0 0;
    border-top: 1px solid #64b6e6;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/marker_Info_list.vue